import ModalWrapper from '@Components/Modals/ModalWrapper/ModalWrapper';
import AssetStatusServices from '@Services/AssetStatus.services.ts';
import { TaxStatus } from '@Types/Asset.types';
import { handleRequestError } from '@Utils/request.utils';
import { ErrorDisplay, Toast } from '@kg-internal/pv3-uikit';
import { useState } from 'react';

type Props = {
  show: boolean;
  assetStatus?: TaxStatus;
  onClose: () => void;
  onSuccess: () => void;
};

const DeleteAssetStatus = ({ show, assetStatus, onClose, onSuccess }: Props) => {
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

  const deleteTaxStatus = () => {
    AssetStatusServices.disableAssetStatus(assetStatus?.id)
      .then(() => {
        Toast.success('Asset status deleted successfully.');
        onSuccess();
        onClose();
      })
      .catch((errorResponse) => handleRequestError(errorResponse, setErrorMessage, true));
  };

  return (
    <div className='modal--fit-content modal--w-30vw modal--pt-25vh'>
      <ModalWrapper
        title='Delete Asset Status'
        show={show}
        handleClose={onClose}
        primaryButtonText='Confirm'
        primaryAction={() => deleteTaxStatus()}>
        {errorMessage ? (
          <ErrorDisplay inline details={errorMessage} />
        ) : (
          <div>
            <p>
              <b>Description</b> : {assetStatus?.description}
            </p>
            <br />
          </div>
        )}
      </ModalWrapper>
    </div>
  );
};

export default DeleteAssetStatus;
